export default __webpack_public_path__ + "static/099-fb2a48bb00b8b3c6560c27418af52eef.jpg";